module.exports = __webpack_public_path__ + "assets/img/FB.c5d64b15.png";